import { useTranslation } from "react-i18next";

interface StatusBadgeProps {
  status: string;
  size?: "sm" | "md";
}

const statusConfig: Record<string, { bg: string; text: string; icon: string; key: string }> = {
  "Processing": { bg: "bg-amber-100", text: "text-amber-700", icon: "ri-loader-4-line", key: "status_processing" },
  "In Transit": { bg: "bg-sky-100", text: "text-sky-700", icon: "ri-truck-line", key: "status_in_transit" },
  "Out for Delivery": { bg: "bg-violet-100", text: "text-violet-700", icon: "ri-e-bike-line", key: "status_out_for_delivery" },
  "Delivered": { bg: "bg-emerald-100", text: "text-emerald-700", icon: "ri-checkbox-circle-line", key: "status_delivered" },
  "Exception": { bg: "bg-red-100", text: "text-red-700", icon: "ri-error-warning-line", key: "status_exception" },
};

export default function StatusBadge({ status, size = "md" }: StatusBadgeProps) {
  const { t } = useTranslation();
  const config = statusConfig[status] || { bg: "bg-gray-100", text: "text-gray-700", icon: "ri-question-line", key: "" };
  const label = config.key ? t(config.key) : status;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap ${config.bg} ${config.text} ${
        size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm"
      }`}
    >
      <div className={`flex items-center justify-center ${size === "sm" ? "w-3 h-3" : "w-4 h-4"}`}>
        <i className={config.icon} />
      </div>
      {label}
    </span>
  );
}
